import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import styles from './Modal.module.scss';

const Modal = ({
  open,
  onClose,
  children,
  layoutId,
  hideCloseButton = false,
  disableOverlayClose = false,
}) => {
  const [mount, setMount] = React.useState(false);
  const closeRef = React.useRef(null);
  const handleInnerClick = React.useCallback((event) => {
    event.stopPropagation();

  }, []);

  const handleFocusExit = React.useCallback(() => {
    closeRef.current.focus();
  }, []);

  React.useEffect(() => {
    setMount(true);

    if (open) {
      const oldFocus = document.querySelector(':focus');
      closeRef.current.focus();

      return () => {
        oldFocus.focus();
      }
    }
  }, [open]);

  return (
      <AnimatePresence>
        {open && (
          <div className={styles.modal}>
            <motion.div
              className={styles.root}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5, type: 'tween', ease: 'easeInOut' }}
              onClick={disableOverlayClose ? undefined : onClose}
            />
            <motion.div
              // ref={ref}
              className={styles.inner}
              onClick={handleInnerClick}
              layoutId={layoutId}
              initial={!!layoutId ? undefined : { opacity: 0 }}
              animate={!!layoutId ? undefined : { opacity: 1 }}
              exit={!!layoutId ? undefined : { opacity: 0 }}
              transition={
                !!layoutId
                  ? undefined
                  : { duration: 0.5, type: 'tween', ease: 'easeInOut' }
              }
            >
              <div className={styles.wrap}>
                <div
                  className={styles.capture}
                  tabIndex={0}
                  onFocus={handleFocusExit}
                />
                {!hideCloseButton && (
                  <div
                    className={styles.close}
                    ref={closeRef}
                    onClick={onClose}
                  />
                )}
                <div className={styles.content}>{children}</div>
                <div
                  className={styles.capture}
                  tabIndex={0}
                  onFocus={handleFocusExit}
                />
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    )
}

export default Modal;